import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { HealthServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Health_Maternity_Homes = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />
        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
            <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="inner-title2 bas">
                  <h3 className="fontSizeClass"> {t("Maternity Homes")} </h3>
                </div>
                <div className="health-dept-table" style={{ width: "100%" }}>
                  <table
                    width="95%"
                    border={0}
                    align="center"
                    cellPadding={2}
                    cellSpacing={2}
                    className="table table-bordered officials"
                  >
                    <tbody>
                      <tr
                        bgcolor="#302ba0"
                        tabIndex={0}
                        align="center"
                        valign="middle"
                        style={{ color: "white", fontWeight: "bold" }}
                      >
                        <td width="27%" className="text-white tble-brder-left">
                          {t("Name")}
                        </td>
                        <td width="32%" className="text-white">
                          {t("Address")}
                        </td>
                        <td width="24%" className="text-white">
                          {t("Mobile No")}
                        </td>
                        <td width="17%" className="text-white tble-brder-right">
                          {t("Beds")}
                        </td>
                      </tr>
                      <tr tabIndex={0} align="left" valign="top">
                        <td width="27%">{t("North Maternity Home")}</td>
                        <td width="32%">
                          {t("22, Nilmoni Mitra St")}.
                          <br />
                          Kol - 6, Ward - 17
                        </td>
                        <td width="24%">{t("Ph.")}: 2555 7372</td>
                        <td width="17%">20 </td>
                      </tr>
                      <tr tabIndex={0} align="left" valign="top">
                        <td width="27%">{t("Champamoni Maternity Home")}</td>
                        <td width="32%">
                          {t("59, Christopher Road, Kol - 46, Ward - 58")}
                        </td>
                        <td width="24%">{t("Ph.")}: 2865 0980</td>
                        <td width="17%">20 </td>
                      </tr>
                      <tr tabIndex={0} align="left" valign="top">
                        <td width="27%">{t("Khiddirpore Materity Home")}</td>
                        <td width="32%">
                          {t("34, Ekbalpur Road, Kol - 23")}, <br />
                          {t("Ward - 77")}
                        </td>
                        <td width="24%">{t("Ph.")}: 2449 3560</td>
                        <td width="17%">40 </td>
                      </tr>
                      <tr tabIndex={0} align="left" valign="top">
                        <td width="27%">{t("Garden Reach Maternity Home")}</td>
                        <td width="32%">
                          {t("2B, Dilwarajab Lane, Kol - 24, Ward - 134")}
                        </td>
                        <td width="24%">{t("Ph.")}: 2469 1358</td>
                        <td width="17%">20</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_Maternity_Homes;
